import * as React from "react";
import styled from "styled-components";

interface AdMetricsProps {
  duration: number;
  slate: number | undefined;
}

export const AdMetrics: React.FC<AdMetricsProps> = ({ duration, slate }) => {
  return (
    <MetricsContainer>
      <MetricItem>
        <MetricIcon
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/35f5428bd55fee80e51eeabc87dc94bce59c41c2d87c29d288270558743d0c91?placeholderIfAbsent=true&apiKey=3ff581d1ced34e86ad9fe32423196fa7"
          alt="Duration icon"
        />
        <MetricLabel>Duração</MetricLabel>
        <MetricValue>{isNaN(duration) ? 0 : duration}s</MetricValue>
      </MetricItem>
      <MetricItem>
        <MetricIcon
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/20e25d14184b5350b0fcb635f11a2b1dba96844565301a82d02b286aa57aa90a?placeholderIfAbsent=true&apiKey=3ff581d1ced34e86ad9fe32423196fa7"
          alt="Slate icon"
        />
        <MetricLabel>{slate ? "" :  "Sem"} Slate</MetricLabel>
        {slate ? (<MetricValue>{slate}s</MetricValue>) : (<></>)}
        
      </MetricItem>
    </MetricsContainer>
  );
};

const MetricsContainer = styled.div`
  border-radius: 0 0 3px 3px;
  background-color: rgba(177, 216, 255, 1);
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: #505050;
  fill: #505050;
  white-space: nowrap;
  flex-wrap: wrap;
  padding: 10px;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Montserrat";
  margin-bottom: 10px;
  height: 50px;
  @media (max-width: 991px) {
    white-space: initial;
    padding: 0 20px;
  }
`;

const MetricItem = styled.div`
  display: flex;
  gap: 6px;
  @media (max-width: 991px) {
    white-space: initial;
  }
  height: 24px;
  margin-left: 2px;
`;

const MetricIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  align-self: center;
`;

const MetricLabel = styled.div`
  margin: auto 0;
`;

const MetricValue = styled.div`
  z-index: 10;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 1.7;
  padding: 0 11px;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;
